import { Avatar, Stack, Text } from '@cheqroom/ui';
import { FC, ReactNode } from 'react';

export type SelectableListStepListItemProps = {
	name: string;
	/** When set, shown as the avatar image; otherwise initials from `name` are used. */
	logoUrl?: string;
	trailing: ReactNode;
};

export const ListItem: FC<SelectableListStepListItemProps> = ({ name, logoUrl, trailing }) => (
	<Stack justify="between" align="center">
		<Stack justify="between" align="center" spacing="loose">
			<Avatar url={logoUrl} name={name} />
			<Text weight="semibold">{name}</Text>
		</Stack>
		{trailing}
	</Stack>
);

ListItem.displayName = 'SelectableListStep.ListItem';
